import React, { useContext } from 'react';
import { themeContext } from 'contexts/theme_context/ThemeContext';
import { languageContext } from 'contexts/language_context/LanguageContext';
import './ThemeButton.css'; 

const ThemeButton = () => {
  const { webtheme, changeThemeTo } = useContext(themeContext);
  const { weblanguage } = useContext(languageContext);

  const toggleTheme = () => {
    changeThemeTo(webtheme === 'light' ? 'dark' : 'light');
  };

  const iconClass = `fa-solid ${webtheme === 'light' ? 'fa-sun' : 'fa-moon'} theme-icon ${webtheme}-text ${weblanguage === 'ar' ? 'order-2' : 'order-1'}`;

  return (
    <div className="theme-button d-flex align-items-center justify-content-center cursor" onClick={toggleTheme}>
      <i className={iconClass}></i>
    </div>
  );
};

export default ThemeButton;
